import each from 'lodash-es/each';

import getFontClass from '../../utils/getFontClass';

const extractPreheading = (preheadings) => {
  let text = '';
  each(preheadings, (preheading) => {
    text += `<span class="${getFontClass(preheading.pre_heading_size)}">${preheading.pre_heading_text}</span>`;
  });
  return text;
};

const extractHeading = (headings) => {
  let text = '';
  each(headings, (heading) => {
    text += `<span class="${getFontClass(heading.heading_size)}">${heading.heading_text}</span>`;
  });
  return text;
};

const extractSubheading = (subheadings) => {
  let text = '';
  each(subheadings, (subheading) => {
    text += `<span class="${getFontClass(subheading.sub_heading_text)}">${subheading.sub_heading_text}</span>`;
  });
  return text;
};

// export default (settings, module_name, index) => {
export default (settings, module_name) => {
  const preheading = extractPreheading(settings.pre_heading);
  const heading = extractHeading(settings.heading);
  const subheading = extractSubheading(settings.sub_heading);

  const content_html = `
  <h2 class="Module-${module_name}__Preheading">
    ${preheading}
  </h2>
  <h1 class="Module-${module_name}__Heading">
    ${heading}
  </h1>
  <h3 class="Module-${module_name}__Subheading p">
    ${subheading}
  </h3>
  `;
  return content_html;
};
